import StepTextWizard from "@/components/StepTextWizard";

const STEPS = [
  { n: 1, code: "1", key: "work", label: "Work", phase: "PEOPLE", placeholder: "Core technical tasks, workflow dependencies and performance pressures required by the strategy." },
  { n: 2, code: "2", key: "people", label: "People", phase: "PEOPLE", placeholder: "Current skill levels, capabilities, motivations and expectations of the workforce." },
  { n: 3, code: "3", key: "formalStructure", label: "Formal Structure", phase: "PEOPLE", placeholder: "Organisational design, standardised procedures, metrics and reporting loops." },
  { n: 4, code: "4", key: "informalStructure", label: "Informal Structure", phase: "PEOPLE", placeholder: "Unwritten cultural rules, values, behavioural norms and political drivers." },
];

export default function Congruence() {
  return <StepTextWizard toolType="congruence" steps={STEPS} accent="emerald" titlePlaceholder="Congruence diagnosis title…" defaultTitle="Untitled Congruence Diagnosis" viewPath={(id) => `/congruence/${id}/view`} finaliseLabel="Finalise Diagnosis" testidPrefix="congruence" />;
}
